import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import envConfig from "env-config";

const useRemoteIcons = () => {
  const fetchJson = () =>
    axios.get(
      `https://${envConfig.REACT_APP_STATIC_BASE_URL}/SectionImages/svgIcons/iconsManifest.json`,
    );

  const { data, isLoading } = useQuery({
    queryKey: ["remoteIcons"],
    queryFn: fetchJson,
    staleTime: 30000,
  });

  const remoteIcons = useMemo(
    () =>
      data?.data.map((value: any) => ({
        name: value.name,
        fileName: value.file,
        url: `https://${envConfig.REACT_APP_STATIC_BASE_URL}/SectionImages/svgIcons/${value.file}`,
      })),
    [data],
  );

  return {
    remoteIcons,
    remoteIconsLoading: isLoading,
  };
};

export default useRemoteIcons;
